var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadershipicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4 31.2C32.4 24.3144 27.9096 18.4656 21.7068 16.4028C23.8188 14.8752 25.2 12.3984 25.2 9.59995C25.2 4.96915 21.4308 1.19995 16.8 1.19995C12.1692 1.19995 8.39995 4.96915 8.39995 9.59995C8.39995 12.3984 9.78115 14.8752 11.8932 16.4028C5.69035 18.4656 1.19995 24.3144 1.19995 31.2V32.4H32.4V31.2ZM10.8 9.59995C10.8 6.29155 13.4916 3.59995 16.8 3.59995C20.1084 3.59995 22.8 6.29155 22.8 9.59995C22.8 12.9084 20.1084 15.6 16.8 15.6C13.4916 15.6 10.8 12.9084 10.8 9.59995ZM3.65395 30C4.26235 23.2812 9.92515 18 16.8 18C23.6748 18 29.3376 23.2812 29.946 30H3.65395Z",
    fill: "#AD1F25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1067 42.8028C50.2187 41.2752 51.5999 38.7984 51.5999 36C51.5999 31.3692 47.8307 27.6 43.1999 27.6C38.5691 27.6 34.7999 31.3692 34.7999 36C34.7999 38.7984 36.1811 41.2752 38.2931 42.8028C32.0903 44.8656 27.5999 50.7144 27.5999 57.6V58.8H58.7999V57.6C58.7999 50.7144 54.3095 44.8656 48.1067 42.8028ZM37.1999 36C37.1999 32.6916 39.8915 30 43.1999 30C46.5083 30 49.1999 32.6916 49.1999 36C49.1999 39.3084 46.5083 42 43.1999 42C39.8915 42 37.1999 39.3084 37.1999 36ZM30.0539 56.4C30.6623 49.6812 36.3251 44.4 43.1999 44.4C50.0747 44.4 55.7375 49.6812 56.3459 56.4H30.0539Z",
    fill: "#AD1F25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4 22.8V8.39999H34.0968L38.0484 4.44839L36.3516 2.75159L29.5032 9.59999L36.3516 16.4484L38.0484 14.7516L34.0968 10.8H42V22.8H44.4Z",
    fill: "#AD1F25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7515 45.2484L18.7031 49.2H10.7999V37.2H8.3999V51.6H18.7031L14.7515 55.5516L16.4483 57.2484L23.2967 50.4L16.4483 43.5516L14.7515 45.2484Z",
    fill: "#AD1F25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadershipicon2);
export default __webpack_public_path__ + "static/media/leadershipicon2.b36377613c6a4745fb6cad242e52ffa0.svg";
export { ForwardRef as ReactComponent };